<template>
	<span v-if="visible">{{ textPrefix }}<it-link v-if="url" :to="url" v-preview="linkToPreviewKey(url)">{{ ln }}</it-link>{{ textSuffix }}</span>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import ItLink from "@/router/ItLink.vue";
import {linkToPreviewKey} from "@/utils/WebPreview";

const props = defineProps<{
	text?: string;
	url?: string;
	linkName?: string;
}>();
const LINK = "[[[link]]]";

const visible = computed<boolean>(() => !!props.text);
const linkIndex = computed<number>(() => {
	if (!props.text || !props.url) return -1;
	return props.text.indexOf(LINK);
});
const ln = computed<string>(() => !!props.linkName ? props.linkName : props.url);

const textPrefix = computed<string>(() => {
	if (linkIndex.value >= 0) {
		return props.text.substring(0, linkIndex.value);
	} else return props.text;
});

const textSuffix = computed<string>(() => {
	if (linkIndex.value >= 0) {
		return props.text.substring(linkIndex.value + LINK.length);
	} else return "";
});

</script>

<style>

</style>